exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-f1ffa194] .el-table__header,[data-v-f1ffa194] .el-table__body{width:100% !important\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/vippay-system-manager-merchant/src/components/withdrawBank/index.vue"],"names":[],"mappings":";AACA,sEAAsE,qBAAqB;CAC1F","file":"index.vue","sourcesContent":["\n[data-v-f1ffa194] .el-table__header,[data-v-f1ffa194] .el-table__body{width:100% !important\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f1ffa194","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/withdrawBank/index.vue
// module id = Bz4A
// module chunks = 1